export const mockedRequester = (x, key) => () => ({
    key: [key],
    invalidationKey: [key],
    request: () => x,
    data: x,
    fetchAndTransform: () => x
});
export default mockedRequester;
